<script lang="ts" setup>
  import {
    definePropsEntry,
    defineEmitsEntry,
  } from "frontend/utils/base-calendar-utils";
  import { CalendarEntryVisual } from "frontend/interfaces/calendar";

  defineProps(definePropsEntry<CalendarEntryVisual>());
  defineEmits(defineEmitsEntry());
</script>

<template>
  <div class="visual-line"></div>
</template>

<style lang="scss" scope>
  @use "shared/styles/colors";

  .visual-line {
    border-bottom: 1px solid colors.$color-calendar__visual-line;
  }
</style>
